export const normalizeText = (value) => String(value ?? "").trim();
const resolveAdvanceDisplay = (value) =>
  normalizeText(value).toLowerCase() === "activo" ? "Inactivo" : "Activo";

export const parseDateTimeValue = (value) => {
  const raw = normalizeText(value);
  if (!raw || raw === "-") return null;

  const match = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2}))?$/);
  if (match) {
    const [, day, month, year, hours = "00", minutes = "00"] = match;
    const parsed = new Date(`${year}-${month}-${day}T${hours}:${minutes}:00`);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatDate = (value) => {
  const parsed = parseDateTimeValue(value);
  return parsed
    ? parsed.toLocaleDateString("es-AR", { day: "2-digit", month: "2-digit", year: "numeric" })
    : "";
};

export const safeJoin = (values, separator = " · ") =>
  values.map(normalizeText).filter(Boolean).join(separator);

export const parseJsonContext = (value) => {
  if (typeof value !== "string" || !value.trim()) return {};
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

export const normalizeLostTerminalItem = (item = {}) => {
  const scoreRaw = item?.scorePrioridad ?? item?.ScorePrioridad;
  const numericScore = Number(scoreRaw);

  return {
    id: Number(item?.id || item?.Id || 0),
    processId: Number(item?.id || item?.Id || 0),
    processCode: normalizeText(item?.procesoCodigo || item?.ProcesoCodigo || "TERMINAL_EXTRAVIADA_V2"),
    processSlug: normalizeText(item?.procesoSlug || item?.ProcesoSlug || "terminal-extraviada"),
    commerceName: normalizeText(item?.comercio || item?.Comercio || item?.razonSocial || item?.RazonSocial) || "Sin comercio",
    cuit: normalizeText(item?.cuit || item?.Cuit),
    terminal: normalizeText(item?.numeroTerminal || item?.NumeroTerminal),
    advanceActive: resolveAdvanceDisplay(item?.anticipoActivo || item?.AnticipoActivo),
    province: normalizeText(item?.provincia || item?.Provincia),
    phone: normalizeText(item?.telefono || item?.Telefono),
    status: normalizeText(item?.estadoLabel || item?.EstadoLabel || item?.estadoActual || item?.EstadoActual) || "Sin estado",
    score: Number.isFinite(numericScore) ? numericScore : null,
    priority: normalizeText(item?.prioridad || item?.Prioridad),
    irregularity: "",
    segment: "",
    reason: normalizeText(item?.motivoCreacion || item?.MotivoCreacion),
    suggestedAction: normalizeText(item?.accionPermitida || item?.AccionPermitida),
    context: "",
    lastContactAt: "",
    nextContactAt: normalizeText(item?.fechaProximaAccion || item?.FechaProximaAccion),
    responsibleName: normalizeText(item?.responsable || item?.Responsable),
    suggestedMessage: normalizeText(item?.mensajeSugerido || item?.MensajeSugerido),
    canManage: item?.puedeGestionar !== false,
    canTake: Boolean(item?.puedeTomar),
    canAssign: Boolean(item?.puedeAsignar),
    canRelease: Boolean(item?.puedeLiberar),
    readOnly: Boolean(item?.esSoloLectura),
    versionToken: normalizeText(item?.versionToken || item?.VersionToken),
    processOriginLabel: normalizeText(item?.procesoOrigenLabel || item?.ProcesoOrigenLabel),
    riskLevel: item?.nivelRiesgo ?? item?.NivelRiesgo ?? null,
    raw: item,
  };
};

export const normalizeLostTerminalDetail = (detailResponse) => {
  const instance = detailResponse?.instancia || {};
  const history = Array.isArray(detailResponse?.historial) ? detailResponse.historial : [];
  const context = parseJsonContext(instance?.datosContexto || instance?.DatosContexto);

  const contextLines = [
    context?.motivo,
    context?.motivoCreacion,
    context?.detalle,
    context?.ultimaFechaFacturacion ? `Última facturación: ${context.ultimaFechaFacturacion}` : "",
    context?.ultimaVenta ? `Última venta: ${context.ultimaVenta}` : "",
    Number.isFinite(Number(context?.diasSinVentas)) ? `Días sin ventas: ${context.diasSinVentas}` : "",
    normalizeText(instance?.procesoOrigenLabel || instance?.ProcesoOrigenLabel)
      ? `Origen: ${normalizeText(instance?.procesoOrigenLabel || instance?.ProcesoOrigenLabel)}`
      : "",
  ].filter(Boolean);

  return {
    irregularity: normalizeText(context?.irregularity || context?.irregularidad || context?.classification || context?.clasificacion),
    segment: normalizeText(context?.segment || context?.segmento),
    reason: normalizeText(instance?.motivoCreacion || instance?.MotivoCreacion || context?.motivo || context?.motivoCreacion),
    suggestedAction: normalizeText(instance?.accionPermitida || instance?.AccionPermitida || context?.accionSugerida || context?.suggestedAction),
    context: contextLines.join(" "),
    lastContactAt: normalizeText(history[0]?.fecha || history[0]?.Fecha),
    nextContactAt: normalizeText(instance?.fechaProximaAccion || instance?.FechaProximaAccion),
    responsibleName: normalizeText(instance?.responsable || instance?.Responsable),
    suggestedMessage: normalizeText(instance?.mensajeSugerido || instance?.MensajeSugerido),
  };
};

export const filterLostTerminalRows = (rows, search) => {
  const needle = normalizeText(search).toLowerCase();
  if (!needle) return rows;

  return rows.filter((item) =>
    [
      item.commerceName,
      item.cuit,
      item.terminal,
      item.province,
      item.phone,
      item.responsibleName,
    ]
      .filter(Boolean)
      .some((value) => value.toLowerCase().includes(needle))
  );
};

export const resolveActionLabel = (item) =>
  item.readOnly || item.canManage === false ? "Ver detalle" : "Gestionar";
